// extracted by mini-css-extract-plugin
module.exports = {"text":"headlineSkins-mediumOnWide-text-1169e35a"};